import React from 'react';
import { PubSub } from '../../../utils/eventUtils';

const initialModalState = {
  config: {},
  component: () => <></>,
};

export const withModalState = (DialogBase) => {
  return () => {
    const [isOpen, setOpen] = React.useState(false);
    const [modal, setModal] = React.useState(initialModalState);

    const handleClose = () => {
      setOpen(false);
      setTimeout(() => {
        setModal(initialModalState);
      }, 500);
    };

    React.useEffect(() => {
      PubSub.subscribe('modal:show', (nextModal) => {
        setOpen(true);
        setModal(nextModal);
      });
      PubSub.subscribe('modal:hide', handleClose);
    }, []);

    return (
      <DialogBase open={isOpen} onClose={handleClose} {...modal.config}>
        {React.createElement(modal.component, {
          data: modal.data,
          close: handleClose,
        })}
      </DialogBase>
    );
  };
};
